import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { querySiteFactorBySiteId } from '@/api/api';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { downloadFile } from '@/api/manage';
export default {
  data: function data() {
    return {
      queryParam: {
        equipName: '',
        code: ''
      },
      dataList: [],
      nameList: [],
      url: '',
      columns: [{
        title: '设备名称',
        dataIndex: 'name',
        key: 'name',
        align: 'center',
        scopedSlots: {
          customRender: 'name'
        }
      }, {
        title: 'Code',
        dataIndex: 'codeName',
        key: 'codeName',
        align: 'center',
        scopedSlots: {
          customRender: 'codeName'
        }
      }, {
        title: '因子名称',
        dataIndex: 'title',
        key: 'title',
        align: 'center',
        scopedSlots: {
          customRender: 'title'
        }
      }, {
        title: '单位',
        dataIndex: 'unitName',
        key: 'unitName',
        align: 'center',
        scopedSlots: {
          customRender: 'unitName'
        }
      }]
    };
  },
  mounted: function mounted() {},
  mixins: [GetSiteIdMixin],
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();

      if (ids[0] == 1) {
        this.siteId = ids[1];
        this.getData();
      }
    }
  },
  methods: {
    // 导出
    handleExportXls: function handleExportXls(s) {
      var url = this.url + '/export';
      downloadFile(s, url, this.queryParam);
    },
    // 搜索
    searchQuery: function searchQuery() {
      this.getData();
    },
    getData: function getData() {
      var _this = this;

      this.dataList = [];
      this.nameList = [];
      querySiteFactorBySiteId(this.siteId).then(function (res) {
        if (res.success) {
          var obj = {};
          res.result.factors.forEach(function (item, index) {
            obj[item.code] = item;
          });
          var dataObj = {};
          res.result.records.forEach(function (item, index) {
            for (var i in item) {
              if (obj[i]) {
                dataObj = JSON.parse(JSON.stringify(obj[i]));
                dataObj['codeName'] = item[i];
                dataObj['name'] = item['name'];

                _this.dataList.push(dataObj);

                dataObj = {};

                _this.nameList.push(item['name']);
              }
            }
          });
        } else {
          _this.dataList = [];
        }
      });
    }
  }
};